import { nonDefaultRefinementsFilter } from '@/components/Headings/utils';
import { fullyDecodeURI } from '@/components/SearchResultsFacets/utils';
import {
    ITEM_LOCATION_BOPIW,
    ITEM_LOCATION_PRICING_FACET_KEY,
    REFINEMENT_KEY_BUY_IN_DISTRIBUTION_CENTER,
    REFINEMENT_KEY_DELIVERY,
    REFINEMENT_KEY_IN_STOCK,
    REFINEMENT_KEY_IN_WAREHOUSE,
    REFINEMENT_KEY_TWO_DAY_DELIVERY,
    REFINE_QUERY_DELIMITER,
} from '@/constants/index';

export const getRatingsLabel = (rating: string): string => {
    return rating.replace('&', 'Stars &');
};

// Filters out refinements that should not be displayed in the page title or heading
export function refinementValidForTitle({
    filterType,
    refinement,
}: {
    filterType?: string;
    refinement: string;
}): boolean {
    if ((!filterType || !filterType.trim()) && (!refinement || !refinement.trim())) {
        return false;
    }

    const lowerFilterType = filterType?.toLowerCase();

    // Filter types are just the refinement key, doesn't matter value
    const excludedFilterTypes = [
        ITEM_LOCATION_PRICING_FACET_KEY.toLowerCase(),
        ITEM_LOCATION_BOPIW.toLowerCase(),
        REFINEMENT_KEY_BUY_IN_DISTRIBUTION_CENTER.toLowerCase(),
    ];

    if (lowerFilterType && excludedFilterTypes.includes(lowerFilterType)) {
        return false;
    }

    // Full refinements are key + value
    const excludedRefinements = [
        REFINEMENT_KEY_DELIVERY,
        REFINEMENT_KEY_IN_STOCK,
        REFINEMENT_KEY_IN_WAREHOUSE,
        REFINEMENT_KEY_TWO_DAY_DELIVERY,
    ];

    return !excludedRefinements.includes(refinement);
}

export function getSingleAttrValue(
    refinements?: string | string[] | null,
): string {
    if (!refinements) {
        return '';
    }

    const singleRefineParam = Array.isArray(refinements)
        ? refinements[0]
        : refinements;
    const refine = fullyDecodeURI(singleRefineParam)!;

    const attributes = refine
        .split(REFINE_QUERY_DELIMITER)
        .map(refinement => {
            const [key] = refinement.split(/-(.*)/s);
            return { filterType: key, refinement };
        })
        .filter(nonDefaultRefinementsFilter)
        .filter(refinementValidForTitle);

    if (attributes.length === 1 && attributes[0]) {
        const dashIndex = attributes[0].refinement.indexOf('-');
        return attributes[0].refinement.slice(dashIndex + 1);
    }

    return '';
}

export const splitByCommaOutsideParentheses = (str: string): string[] => {
    const regex = /,(?![^(]*\))/;
    return str.split(regex);
};
